/***
 * Created on 2023/7/20
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useMemo} from 'react';
import {formatTime} from "../../service/datetime";
import myqnapcloud_svg from "../../static/img/service/myqnapcloud.svg";
import { useUA } from 'use-ua-parser-js';
import {useTranslation} from "react-i18next";


function ActivityRecord({data}) {
    const {t} = useTranslation();

    const getDeviceInfo = () => {
        let device_info_str;
        if (data?.metadata) {
            if (data?.metadata?.device && data?.metadata?.device?.device_model) {
                device_info_str = `${data.metadata.device.device_model} ${data.metadata.device.device_hostname}`
            }

            if (data?.metadata?.user_agent) {
                const user_agent = useUA(data.metadata.user_agent);
                if (user_agent?.browser?.name && user_agent?.os?.name) {
                    if (device_info_str) {
                        device_info_str = `${device_info_str} ${user_agent.os.name} ${user_agent.browser.name} ${user_agent.browser.major}`;
                    }
                    else {
                        device_info_str = `${user_agent.os.name} ${user_agent.browser.name} ${user_agent.browser.major}`
                    }
                }
            }

            if (device_info_str) {
                device_info_str = `( ${device_info_str} )`;
            }
        }
        return device_info_str || '';
    }

    const displayBehavior = () => {
        let text;
        const platform = data?.metadata?.platform;
        const twostep = data?.metadata?.method;
        switch (data.action) {
            case 1:
                text = `${t('@Sign in@')} ${data?.app?.display_name}`; break;
            case 2:
                text = `${t('@Sign out@')} ${data?.app?.display_name}`; break;
            case 3:
                text = `${t('@Register device@')} ${data?.metadata?.device_name}} ${data?.metadata?.model_name}`; break;
            case 4:
                text = `${t('@Unregister device@')} ${data?.metadata?.device_name}} ${data?.metadata?.model_name}`; break;
            case 5:
                text = `${t('@Login failed.@')}`; break;
            case 6:
                if (platform === 'facebook') {
                    text = `${t('@Link Facebook@')}`;
                }
                else if (platform === 'google') {
                    text = `${t('@Link Google@')}`;
                }
                else if (platform === 'appleid') {
                    text = `${t('@Link AppleId@')}`;
                }
                break;
            case 7:
                if (platform === 'facebook') {
                    text = `${t('@UnLink Facebook@')}`;
                }
                else if (platform === 'google') {
                    text = `${t('@UnLink Google@')}`;
                }
                else if (platform === 'appleid') {
                    text = `${t('@UnLink AppleId@')}`;
                }
                break;
            case 8:
                if (platform === 'facebook') {
                    text = `${t('@Allow Facebook login@')}`;
                }
                else if (platform === 'google') {
                    text = `${t('@Allow Google login@')}`;
                }
                else if (platform === 'appleid') {
                    text = `${t('@Allow AppleId login@')}`;
                }
                break;
            case 9:
                if (platform === 'facebook') {
                    text = `${t('@Disallow Facebook login@')}`;
                }
                else if (platform === 'google') {
                    text = `${t('@Disallow Google login@')}`;
                }
                else if (platform === 'appleid') {
                    text = `${t('@Disallow AppleId login@')}`;
                }
                break;
            case 10:
                text = `${t('@Changed password@')}`; break;
            case 11:
                // if (twostep === 'sms') {
                //     text = `${t('@Enable 2-step verification@')} ${t('@SMS@')}`;
                // }
                // else if (twostep === 'google_auth') {
                //     text =`${t('@Enable 2-step verification@')} ${t('@Authenticator App@')}`
                // }
                // else {
                //     text =`${t('@Enable 2-step verification@')} ${twostep}`
                // }
                text =`${t('@Enable 2-step verification@')} ${twostep}`
                break;
            case 12:
                // if (twostep === 'sms') {
                //     text = `${t('@Disable 2-step verification@')} ${t('@SMS@')}`;
                // }
                // else if (twostep === 'google_auth') {
                //     text =`${t('@Disable 2-step verification@')} ${t('@Authenticator App@')}`
                // }
                // else {
                //     text =`${t('@Disable 2-step verification@')} ${twostep || ""}`
                // }
                text =`${t('@Disable 2-step verification@')} ${twostep || ""}`
                break;
            case 13:
                text = `${t('@Add login Method@')} ${data?.metadata?.country_code} ${data?.metadata?.number} ${data?.metadata?.email}`; break;
            case 14:
                text = `${t('@Sign out of QNAP account on device@')} ${getDeviceInfo()}`; break;
            case 15:
                text = `${t('@Trusted Device@')} ${getDeviceInfo()}`; break;
            case 16:
                text = `${t('@Untrusted Device@')} ${getDeviceInfo()}`; break;
            case 17:
                text = `${t('@Sign up with@')} ${data?.metadata?.country_code} ${data?.metadata?.number} ${data?.metadata?.email}`; break;
            case 18:
                text = `${t('@Organization created: {org_name}@', {
                    org_name: data?.metadata?.organization_name,
                    interpolation: {
                        prefix: '{',
                        suffix: '}',
                        escapeValue: false
                    }
                })}`
                break;
            case 19:
                text = `${t('@Organization deleted: {org_name}@', {
                    org_name: data?.metadata?.organization_name,
                    interpolation: {
                        prefix: '{',
                        suffix: '}',
                        escapeValue: false
                    }
                })}`
                break;
            case 20:
                text = `${t('@Changed associated email address {email} of QNAP ID@', {
                    email: data.metadata.old_email,
                    interpolation: {
                        prefix: '{',
                        suffix: '}',
                        escapeValue: false
                    }
                })}`;
                break;
            case 21:
                text = `${t('@Removed a phone number {phone_number} associated with QNAP ID@', {
                    phone_number: data.metadata.number,
                    interpolation: {
                        prefix: '{',
                        suffix: '}',
                        escapeValue: false
                    }
                })}`;
                break;
            case 22:
                text = `${t('@Enabled {2sv_method} from 2-Step Verification@', {
                    '2sv_method': data.metadata.method,
                    interpolation: {
                        prefix: '{',
                        suffix: '}',
                        escapeValue: false
                    }
                })}`;
                break;
            case 23:
                text = `${t('@Removed {2sv_method} from 2-Step Verification@', {
                    '2sv_method': data.metadata.method,
                    interpolation: {
                        prefix: '{',
                        suffix: '}',
                        escapeValue: false
                    }
                })}`;
                break;
            case 24:
                text = `${t('@Sign in {app_name} with {2sv_method} verification@', {
                    '2sv_method': data.metadata.method,
                    app_name: data?.app?.display_name,
                    interpolation: {
                        prefix: '{',
                        suffix: '}',
                        escapeValue: false
                    }
                })}`; break;
            case 25:
                text = `${t('@Joined an organization {org_name}@', {
                    org_name: data.metadata?.organization?.name,
                    interpolation: {
                        prefix: '{',
                        suffix: '}',
                        escapeValue: false
                    }
                })}`;
                break;
            case 26:
                text = `${t('@Leave an organization {org_name}@', {
                    org_name: data.metadata?.organization?.name,
                    interpolation: {
                        prefix: '{',
                        suffix: '}',
                        escapeValue: false
                    }
                })}`;
                break;
            case 27:
                text = `${t('@Remove all the trusted devices due to 2-Step Verification disabled@')}`; break;
            case 28:
                text = `${t('@Paired a QNAP Authenticator for 2-Step Verification. {device_name} {model_name} {os_version}@', {
                    device_name: data.metadata?.device?.device_name,
                    model_name: data.metadata?.device?.model_name,
                    os_version: data.metadata?.device?.os_version,
                    interpolation: {
                        prefix: '{',
                        suffix: '}',
                        escapeValue: false
                    }
                })}`;
                break;
            case 29:
                text = `${t('@Remove a QNAP Authenticator device. {device_name} {model_name} {os_version}@', {
                    device_name: data.metadata?.device?.device?.device_name,
                    model_name: data.metadata?.device?.device?.model_name,
                    os_version: data.metadata?.device?.device?.os_version,
                    interpolation: {
                        prefix: '{',
                        suffix: '}',
                        escapeValue: false
                    }
                })}`;
                break;
            case 30:
                text = `${t('@Transfer {device_name} into {org_name}@', {
                    device_name: data.metadata?.device_name,
                    org_name: data.metadata?.organization_name,
                     interpolation: {
                        prefix: '{',
                        suffix: '}',
                        escapeValue: false
                    }
                })}`;
                break;
            default:
                text = JSON.stringify(data);
        }
        return text;
    }

    return (
        <div className="activity">
            <div className="activity__cell activity__header">
                <div className="activity__header__icon" icon-type="app">
                    <img src={`${data?.app?.img_url ? "data.app.img_url" : myqnapcloud_svg}`} />
                </div>
                <div className="activity__header__app-name font-medium">{data?.app?.display_name}</div>
            </div>
            <div className="activity__cell activity__action">
                <div className="activity__action__label text-14 color-dark-gray">{t('@Action@')}</div>
                <div className="activity__action__action-type font-medium">{displayBehavior()}</div>
            </div>
            <div className="activity__cell activity__ip-location">
                <div className="activity__ip-location__label text-14 color-dark-gray">IP/{t('@Location@')}</div>
                <div className="activity__ip-location__info font-medium">{`${data?.from?.ip || ""} ( ${data?.from?.country || ""} )`}</div>
            </div>
            <div className="activity__cell activity__time">
                <div className="activity__time__label text-14 color-dark-gray">{t('@Time@')}</div>
                <div className="activity__time__logged-time font-medium">{formatTime(data?.created_at)}</div>
            </div>
        </div>
    );
}

export default ActivityRecord;